import { Zap } from "lucide-react"

export const ApiMarketingHero = () => (
  <div className="text-center mb-12">
    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 mb-6">
      <Zap size={16} className="text-primary-600" />
      <span className="text-sm font-semibold text-primary-600 uppercase tracking-wide">
        NO DEVELOPER NEEDED
      </span>
    </div>

    <h1 className="text-4xl md:text-5xl font-serif font-bold text-primary-900 mb-4 leading-tight">
      Unlock the Power of Your Data
      <br />
      <span className="inline-flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-primary-300/50"></span>
        Rateflow API
        <span className="w-2 h-2 rounded-full bg-primary-300/50"></span>
      </span>
    </h1>

    <p className="text-lg text-neutral-600 max-w-2xl mx-auto leading-relaxed">
      Build custom projects, automate workflows, and integrate your rate data
      with AI coding tools like Claude and Codex.
    </p>
  </div>
)
